import React, { useEffect, useContext, useState, useRef } from 'react'
import cssPracticeCharacters from './PracticeCharacters.module.scss'
import CharacterDrawerCanvas from '../../LUUtils/Characters/CharacterDrawerCanvas'
import { LUCacheContext } from '../../LearningUnit.js'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "PracticeCharacters"
// 瀏覽器高度 > HEIGHT_PAGE_SIZE_MODE_LARGE_BOUNDAY 則為 Nomal mode的區隔
// 瀏覽器高度 < HEIGHT_PAGE_SIZE_MODE_LARGE_BOUNDAY 且 瀏覽器高度 > HEIGHT_PAGE_SIZE_MODE_SMALL_BOUNDAY 則為 Middle mode的區隔
// 瀏覽器高度 < HEIGHT_PAGE_SIZE_MODE_SMALL_BOUNDAY 則為 Small mode
const HEIGHT_PAGE_SIZE_MODE_LARGE_BOUNDAY = 800
const HEIGHT_PAGE_SIZE_MODE_SMALL_BOUNDAY = 720
// #endregion Constant

// #region Enumeration
const PageDisplayModeEnum = {
    "Normal": 1,
    "Middle": 2,
    "Small": 3
}
// #endregion Enumeration

// #region Member Variables
let mobjComponentCalledFunctionRef = null
let marrStrokeCharList = []
let mblnInitialized = false
let mstrBookCatID = ""
let mstrLUCatSeqNo = ""
let mstrCharacterVideoUrl = "" // 點擊Character後 所播放的Vidoe
let mstrCharacterImageUrl = "" // 點擊Character後 所播放的Vidoe的PosterImage
let mstrCharacterAudioUrl = "" // 點擊Character後 所播放的Audio
let mblnStatePlayAudioWhenVideoPlay = false
// #endregion Member Variables

function PracticeCharacters(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [hasFirstStroke, setHasFirstStroke] = useState(false)
    const [currentCharIndex, setCurrentCharIndex] = useState(0)
    const [pageDisplayMode, setPageDisplayMode] = useState(PageDisplayModeEnum.Normal)
    const [playAudioWhenVideoPlay, setPlayAudioWhenVideoPlay] = useState(false) // 開始播放影片時 是否也播放mp3音檔
    const [isCanvasPlaying, setIsCanvasPlaying] = useState(false)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region Init Context Ref
    // History, Temp, 都是 Cached 在這裏
    // Practice Character 有 Cache Stroke List
    let mobjLUCacheContext = useContext(LUCacheContext)
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        marrStrokeCharList = GetStrokeCharList()
        console.log("marrStrokeCharList: ", marrStrokeCharList)

        InitItemCharacterVideoURL()
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            GlobalLibs.RemoveWindowMessageEvent()
            GlobalLibs.RemoveWindowOnResizeWindow(COMP_NAME)
            mblnInitialized = false
            mrefCleanUp.current()
        }
    }, [props.PathName])

    useEffect(() => {
        mblnStatePlayAudioWhenVideoPlay = playAudioWhenVideoPlay
    }, [playAudioWhenVideoPlay])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        SetPageDisplayMode()
        GlobalLibs.AddWindowMessageEvent(MessageReceived)
        GlobalLibs.AddWindowOnResizeWindow(WindowOnResizeEventHandler, COMP_NAME)
        RegisterLanguageChangeHandler()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        UnregisterLanguageChangeHandler()
    }
    // #endregion Painted Me

    // #region OnTapHandler
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")
    }

    function CanvasPlayOnTapHandler()
    {
        console.log(COMP_NAME + ".CanvasPlayOnTapHandler: ")

        setIsCanvasPlaying(true)

        let objCalledObject = {
            "Action": "PlayCanvas"
        }
        mobjComponentCalledFunctionRef(objCalledObject)
    }

    function StrokeOpenOnTapHandler()
    {
        console.log(COMP_NAME + ".StrokeOpenOnTapHandler: ")

        OpenStrokeWindow()
    }

    // 播放影片時 是否同時播放出mp3音檔
    function PlayAudioWhenVideoPlayOnTapHandler()
    {
        console.log(COMP_NAME + ".ItemCharacterOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if(playAudioWhenVideoPlay === true)
        {
            window.AudioLibs.StopAudio()
        }
        setPlayAudioWhenVideoPlay(!playAudioWhenVideoPlay)
    }

    function ItemCharacterOnTapHandler(CharacterIndex)
    {
        console.log(COMP_NAME + ".ItemCharacterOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        ClearCanvasStroke()
        setCurrentCharIndex(CharacterIndex)
    }

    function ItemVideoOnTapHandler(VideoFN, ImageFN)
    {
        console.log(COMP_NAME + ".ItemVideoOnTapHandler")
        console.log("VideoFN: ", VideoFN)
        console.log("ImageFN: ", ImageFN)

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrlVideo = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Video, VideoFN)
        let strUrlImage = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image, ImageFN)
        console.log("strUrlVideo: ", strUrlVideo)
        console.log("strUrlImage: ", strUrlImage)

        let objCallbackData = {
            "Action": "OpenShowViderPlayerWindow",
            "Arguments": {
                "Title": "",
                "VideoUrl": strUrlVideo,
                "PosterUrl": strUrlImage
            }
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    }

    function CanvasClearOnTapHandler()
    {
        console.log(COMP_NAME + ".CanvasClearOnTapHandler: ")

        ClearCanvasStroke()
    }

    function CanvasSaveOnTapHandler()
    {
        console.log(COMP_NAME + ".CanvasSaveOnTapHandler: ")

        let objCalledObject = {
            "Action": "GetCanvasImag"
        }
        mobjComponentCalledFunctionRef(objCalledObject)
    }

    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL;
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler
    // #endregion Google Classroom

    // #endregion OnTapHandler

    // #region Other Handler
    function CanvasImageGottonHandler(ImageBase64)
    {
        console.log(COMP_NAME + ".CanvasImageGottonHandler: ", ImageBase64)

        console.log("window.gSession.App.BrowserType4LogTrace: ", window.gSession.App.BrowserType4LogTrace)
        // console.log("window.gBrowserTypeEnum: ", window.gBrowserTypeEnum)
        if (window.gSession.App.InApp)
        {
            SaveCharDrawedObjectInApp(ImageBase64);
        }
        else
        {
            SaveCharDrawedObjectNotInApp(ImageBase64);
        }
    }

    function WindowOnResizeEventHandler()
    {
        console.log(COMP_NAME + ".WindowOnResizeEventHandler")

        SetPageDisplayMode()
    }

    function VideoOnPlayEventHandler()
    {
        console.log(COMP_NAME + ".VideoOnPlayEventHandler", mblnStatePlayAudioWhenVideoPlay)

        if(mblnStatePlayAudioWhenVideoPlay)
        {
            window.AudioLibs.PlayAudio(mstrCharacterAudioUrl)
        }
    }
    // #endregion Other Handler

    // #region LoadingMask and Alert

    // function OpenLoadingMask(LoadingMsg)
    // {
    //     console.log("OpenLoadingMask: ", LoadingMsg)

    //     let objCallbackData = {
    //         "Action": "OpenLoadingMask",
    //         "Message": LoadingMsg
    //     }
    //     props.CallbackRef(objCallbackData)
    // }

    // function CloseLoadingMask()
    // {
    //     console.log(COMP_NAME + ".CloseLoadingMask")

    //     let objCallbackData = {
    //         "Action": "CloseLoadingMask"
    //     }
    //     props.CallbackRef(objCallbackData)
    // }

    // #endregion LoadingMask and Alert

    // #region Player
    function CallBCVideoPlayerAreYouReady(iFrameRef)
    {
        console.log(COMP_NAME + ".CallBCVideoPlayerAreYouReady: ", iFrameRef)

        console.log("CallBCVideoPlayerAreYouReady.mstrCharacterVideoUrl:", mstrCharacterVideoUrl)
        console.log("CallBCVideoPlayerAreYouReady.mstrCharacterImageUrl:", mstrCharacterImageUrl)

        let objMessage = {
            "Credential": window.gSession.Acc.Credential,
            "Func": "AreYouReady",
            "Args": {
                "VideoDef": {
                    "VideoUrl": mstrCharacterVideoUrl,
                    "PosterUrl": mstrCharacterVideoUrl
                }
            }
        }
        console.log("objMessage: ", objMessage)
        let strMessage = JSON.stringify(objMessage)
        iFrameRef.contentWindow.postMessage(strMessage, PackageVariablesLibs.SysConfig.AppWebDomain)
    }

    function MessageReceived(Event)
    {
        console.log(COMP_NAME + ".MessageReceived: ", Event)

        // get the origin of event
        let strEventOrigin = Event.origin
        console.log("strEventOrigin: ", strEventOrigin)

        if (
            (strEventOrigin !== PackageVariablesLibs.SysConfig.AppWebDomain) &&
            (strEventOrigin !== "file://")
            )
        {
            // e.g. 從Google Classroom進來的 就不處理
            console.log("Not from my parent, cannot accept")
        }
        else
        {
            console.log("Event.data: ", Event.data)
            console.log("typeof(Event.data): ", typeof (Event.data))

            if (typeof (Event.data) === 'object')
            {
                if (Event.data.source.indexOf('react-devtools') !== -1)
                {
                    return
                }
            }
            if (
                (typeof (Event.data) === 'string') &&
                (Event.data === "")
                )
            {
                return
            }

            let objCallData = JSON.parse(Event.data, true)
            /* 特別注意，
            Prelude的Menu也會trigger message, typeof 會是 function
            Sencha touch 的 DatePicker 也會trigger message, typeof 會是 function
            * 還不知道原因
            */

            console.log("typeof(objCallData): ", typeof (objCallData))

            if (typeof (objCallData) === 'object')
            {
                // note that, Init Hand Shaking 時還沒有DCPCross <- richard: 用top，現階段不需要HandShaking
                // check if the message is from my parent
                // if (strEventOrigin !== mstrWebParentDomain)
                console.log("strEventOrigin: ", strEventOrigin)
                console.log("AppWebDomain: ", PackageVariablesLibs.SysConfig.AppWebDomain)
                if (strEventOrigin !== PackageVariablesLibs.SysConfig.AppWebDomain)
                {
                    console.log("not from my parent, cannot accept")

                    // not from my parent, cannot accept
                    // error 不做事
                }
                else
                {
                    console.log("objCallData.Credential: ", objCallData.Credential)
                    if (objCallData.Credential !== window.gSession.Acc.Credential)
                    {
                        console.log("credential not match")
                        // credential not match
                        // error 不做事
                    }
                    else
                    {
                        console.log("objCallData.Func: ", objCallData.Func)
                        console.log("objCallData: ", objCallData)
                        switch (objCallData.Func)
                        {
                            case "VideoOnPlay":
                                VideoOnPlayEventHandler()
                                break
                            default:
                                break
                        }
                    }
                }
            }
        }
    }

    function IframeOnLoaded(e)
    {
        console.log(COMP_NAME + ".IframeOnLoaded: ", e.target)
        CallBCVideoPlayerAreYouReady(e.target)
    }
    // #endregion Player

    // #region Component Callback
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "RegisterCalledFunctions")
        {
            mobjComponentCalledFunctionRef = CallbackObj.Function
        }
        else if (CallbackObj.Action === "CanvasImageGotton")
        {
            // console.log("CanvasImageGotton: ", CallbackObj.ImageBase64)
            CanvasImageGottonHandler(CallbackObj.ImageBase64)
        }
        else if (CallbackObj.Action === "1stStroke")
        {
            console.log("1stStroke")
            // 可以再這裡 turn on canvas 相關 button: canvas replay/reset/save
            setHasFirstStroke(true)
        }
        else if (CallbackObj.Action === "CanvasStopPlaying")
        {
            console.log("CanvasStopPlaying")
            setIsCanvasPlaying(false)
        }
    }

    function StrokeWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".StrokeWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "StrokeWindowCallbackClose")
        {
            console.log("StrokeWindowCallbackClose")
        }
    }

    // #endregion Component Callback

    // #region Other Functions
    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }
    
    function ClearCanvasStroke()
    {
        let objCalledObject = {
            "Action": "ClearCanvas"
        }
        mobjComponentCalledFunctionRef(objCalledObject)

        // 可以再這裡 turn off canvas 相關 button: canvas replay/reset/save
        setHasFirstStroke(false)
    }

    function SetPageDisplayMode()
    {
        console.log(COMP_NAME + ".SetPageDisplayMode")

        console.log("window.innerHeight: ", window.innerHeight)
        if(window.innerHeight >= HEIGHT_PAGE_SIZE_MODE_LARGE_BOUNDAY)
        {
            setPageDisplayMode(PageDisplayModeEnum.Normal)
        }
        else if(
            (window.innerHeight < HEIGHT_PAGE_SIZE_MODE_LARGE_BOUNDAY) &&
            (window.innerHeight >= HEIGHT_PAGE_SIZE_MODE_SMALL_BOUNDAY)
        )
        {
            setPageDisplayMode(PageDisplayModeEnum.Middle)
        }
        else
        {
            setPageDisplayMode(PageDisplayModeEnum.Small)
        }
    }

    function IsPageDisplayModeMiddle()
    {
        console.log(COMP_NAME + ".IsPageDisplayModeMiddle")
        let blnPageDisplayModeMiddle = false
        if(pageDisplayMode === PageDisplayModeEnum.Middle)
        {
            blnPageDisplayModeMiddle = true
        }
        console.log("blnPageDisplayModeMiddle:", blnPageDisplayModeMiddle)
        return blnPageDisplayModeMiddle
    }

    function IsPageDisplayModeSmall()
    {
        console.log(COMP_NAME + ".IsPageDisplayModeSmall")
        let blnPageDisplayModeSmall = false
        if(pageDisplayMode === PageDisplayModeEnum.Small)
        {
            blnPageDisplayModeSmall = true
        }
        console.log("blnPageDisplayModeSmall:", blnPageDisplayModeSmall)
        return blnPageDisplayModeSmall
    }

    function InitItemCharacterVideoURL()
    {
        console.log(COMP_NAME + ".InitItemCharacterVideoURL: ")

        let strVideoFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.Character[currentCharIndex].MajorVideoFN : props.LUInfo.Character[currentCharIndex].MinorVideoFN

        let strImageFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.Character[currentCharIndex].MajorImgFN : props.LUInfo.Character[currentCharIndex].MinorVideoFN

        console.log("strVideoFN:", strVideoFN)
        console.log("strImageFN:", strImageFN)

        mstrCharacterVideoUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Video, strVideoFN)
        mstrCharacterImageUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image, strImageFN)
        console.log("mstrCharacterVideoUrl:", mstrCharacterVideoUrl)
        console.log("mstrCharacterImageUrl:", mstrCharacterImageUrl)
    }

    /*===========================================
    summary: App 儲存 畫畫資料 
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function SaveCharDrawedObjectInApp(ImageBase64)
    {
        console.log(COMP_NAME + ".SaveCharDrawedObjectInApp: ", ImageBase64)

        // open loading mask?
        var strData = encodeURIComponent(ImageBase64);

        var intAction = window.gConst.ACTION_SAVE_IMAGE_TO_LIBRARY;
        var strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&ImageData=" + strData

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of SaveCharDrawedObjectInApp

    // 儲存 繪畫板 圖片 Not In App 
    function SaveCharDrawedObjectNotInApp(Base64Image)
    {
        console.log("SaveCharDrawedObjectNotInApp: ");

        // var strUrl = Base64Image.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
        // window.open(strUrl, '_parent');

        var objDownload = document.createElement('a');
        objDownload.setAttribute("download", "PracticeCharacters.png");
        objDownload.setAttribute("href", Base64Image);
        objDownload.click();
    }

    function OpenStrokeWindow()
    {
        console.log(COMP_NAME + ".OpenStrokeWindow: ")

        console.log("marrStrokeCharList: ", marrStrokeCharList)
        console.log("currentCharIndex: ", currentCharIndex)
        let strStrokeChar = marrStrokeCharList[currentCharIndex]
        console.log("strStrokeChar: ", strStrokeChar)
        let objCallbackData = {
            "Action": "StrokeWindowOpen",
            "CallbackRef": StrokeWindowCallback,
            "Arguments": strStrokeChar //"你"
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    }

    function GetStrokeCharList()
    {
        console.log(COMP_NAME + ".GetStrokeCharList: ")
        let arrCharacters = props.LUInfo.Character.map(function(Character)
        {
            console.log("Character: ", Character)
            return (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? Character.MajorCharacter : Character.MinorCharacter
        })

        // console.log("CharacterListDef: ", CharacterListDef)
        // console.log("window.gSession.App.BookSeqNo: ", window.gSession.App.BookSeqNo, typeof (window.gSession.App.BookSeqNo))
        // console.log("props.LessonID: ", props.LessonID, typeof (props.LessonID))
        // var intVolume = parseInt(window.gSession.App.BookSeqNo);
        // var intLesson = parseInt(props.LessonID) % 100;

        // let arrCharacters = CharacterListDef.filter(function (Character)
        // {
        //     return (Character.Volume === intVolume) && (Character.Lesson === intLesson)
        // }).map(function (Character)
        // {
        //     return (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? Character.Major : Character.Minor
        // })
        console.log("arrCharacters: ", arrCharacters)

        return arrCharacters
    }

    
    function EnableChangePageByTouchEvent(e)
    {    
        console.log(COMP_NAME + ".EnableChangePageByTouchEvent: ", e)
        let objCallbackData = {
            "Action": "EnableChangePageByTouchEvent"
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    }

    // 用來避免App中 左右滑動時 變成換頁
    function DisableChangePageByTouchEvent(e)
    {    
        console.log(COMP_NAME + ".DisableChangePageByTouchEvent: ", e)
        let objCallbackData = {
            "Action": "DisableChangePageByTouchEvent"
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    }
    // #endregion Other Functions

    // #region Get ClassName and Style
    function GetStyleItemForVideo(ImageFN)
    {
        console.log(COMP_NAME + ".GetStyleItemForVideo: ", ImageFN)

        let objStyle = null
        if (
            (typeof(ImageFN) !== "undefined") &&
            (ImageFN !== null)
            )
        {
            let strImageUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image, ImageFN)
            console.log("strImageUrl: ", strImageUrl)
            objStyle = {
                backgroundImage: `url(${strImageUrl})`
            }
        }
        return objStyle
    }

    function GetStyleItemForCharacter(CharacterFN)
    {
        console.log(COMP_NAME + ".GetStyleItemForCharacter: ", CharacterFN)

        let objStyle = null
        if (
            (typeof(CharacterFN) !== "undefined") &&
            (CharacterFN !== null)
            )
        {
            let strImageUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image, CharacterFN)
            console.log("strImageUrl: ", strImageUrl)
            objStyle = {
                backgroundImage: `url(${strImageUrl})`
            }
        }
        return objStyle
    }

    function GetClsItemForVideo()
    {
        console.log(COMP_NAME + ".GetClsItemForVideo: ")

        let objCls = cssPracticeCharacters.divItemForVideo
        if(IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divItemForVideoForSmallMode
        }
        return objCls
    }

    function GetClsItemForVideoPlayIcon()
    {
        console.log(COMP_NAME + ".GetClsItemForVideoPlayIcon: ")

        let objCls = cssPracticeCharacters.divItemForVideoPlayIcon
        if(IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divItemForVideoPlayIconForSmallMode
        }
        return objCls
    }

    function GetClsItemCharacter(StateCurrentCharIndex, CharacterIndex)
    {
        console.log(COMP_NAME + ".GetClsItemCharacter: ", StateCurrentCharIndex, CharacterIndex)

        let objCls = null
        if(IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divItemForCharacterForSmallMode
        }
        else
        {
            objCls = cssPracticeCharacters.divItemForCharacter
        }

        if(StateCurrentCharIndex === CharacterIndex)
        {
            if(IsPageDisplayModeSmall())
            {
                objCls = cssPracticeCharacters.divItemForCharacterSelectedForSmallMode
            }
            else
            {
                objCls = cssPracticeCharacters.divItemForCharacterSelected
            }
        }

        return objCls
    }

    function GetClsCharacterList()
    {
        console.log(COMP_NAME + ".GetClsCharacterList: ")

        let objCls = cssPracticeCharacters.divCharacterScrollArea
        if(IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divCharacterScrollAreaForSmallMode
        }
        return objCls
    }

    function GetClsSubTitleText()
    {
        let objCls = cssPracticeCharacters.divSubTitleText
        if(IsPageDisplayModeMiddle() || IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divSubTitleTextForSmallMode
        }
        return objCls
    }

    function GetClsCharacterVideoPlayerIFrameArea()
    {
        console.log(COMP_NAME + ".GetClsCharacterVideoPlayerIFrameArea: ")

        let objCls = cssPracticeCharacters.divCharacterVideoPlayerIFrameArea
        if(IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divCharacterVideoPlayerIFrameAreaForSmallMode
        }
        return objCls
        
    }

    function GetClsPlayAudioWhenVideoPlayIcon()
    {
        console.log(COMP_NAME + ".GetClsPlayAudioWhenVideoPlayIcon")
        let objCls = playAudioWhenVideoPlay ? cssPracticeCharacters.divPlayAudioWhenVideoPlayIcon : cssPracticeCharacters.divPlayAudioWhenVideoPlayIconMute
        return objCls
    }

    function GetClsCharacterDrawerCanvasArea()
    {
        console.log(COMP_NAME + ".GetClsCharacterDrawerCanvasArea: ")

        let objCls = cssPracticeCharacters.divCharacterDrawerCanvasArea
        if(IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divCharacterDrawerCanvasAreaForSmallMode
        }
        return objCls   
        
    }

    function GetClsPlayButton()
    {
        console.log(COMP_NAME + ".GetClsPlayButton: ")
        let objCls = cssPracticeCharacters.btnPlayDisable
        if (
            hasFirstStroke &&
            !isCanvasPlaying
            )
        {
            objCls = cssPracticeCharacters.btnPlay
        }
        return objCls
    }

    function GetClsEditButtonForSmallMode()
    {
        console.log(COMP_NAME + ".GetClsEditButtonForSmallMode: ")
        let objCls = cssPracticeCharacters.btnEditForSmallModeDisable
        if (!isCanvasPlaying)
        {
            objCls = cssPracticeCharacters.btnEditForSmallMode
        }
        return objCls
    }

    function GetClsPlayButtonForSmallMode()
    {
        console.log(COMP_NAME + ".GetClsPlayButtonForSmallMode: ")
        let objCls = cssPracticeCharacters.btnPlayDisableForSmallMode
        if (
            hasFirstStroke &&
            !isCanvasPlaying
            )
        {
            objCls = cssPracticeCharacters.btnPlayForSmallMode
        }
        return objCls
    }

    function GetClsDownloadButton()
    {
        console.log(COMP_NAME + ".GetClsDownloadButton: ")
        let objCls = cssPracticeCharacters.btnDownloadDisable
        if (
            hasFirstStroke &&
            !isCanvasPlaying
            )
        {
            objCls = cssPracticeCharacters.btnDownload
        }
        return objCls
    }

    function GetClsClearButton()
    {
        console.log(COMP_NAME + ".GetClsClearButton: ")
        let objCls = cssPracticeCharacters.btnClearDisable
        if (
            hasFirstStroke &&
            !isCanvasPlaying
            )
        {
            objCls = cssPracticeCharacters.btnClear
        }
        return objCls
    }

    function GetClsEditButton()
    {
        console.log(COMP_NAME + ".GetClsEditButton: ")
        let objCls = cssPracticeCharacters.btnEditDisable
        if (!isCanvasPlaying)
        {
            objCls = cssPracticeCharacters.btnEdit
        }
        return objCls
    }
    
    function GetClsDownloadButtonForSmallMode()
    {
        console.log(COMP_NAME + ".GetClsDownloadButtonForSmallMode: ")

        let objCls = cssPracticeCharacters.btnDownloadDisableForSmallMode
        if (
            hasFirstStroke &&
            !isCanvasPlaying
            )
        {
            objCls = cssPracticeCharacters.btnDownloadForSmallMode
        }
        return objCls
    }

    function GetClsClearButtonForSmallMode()
    {
        console.log(COMP_NAME + ".GetClsClearButtonForSmallMode: ")
        let objCls = cssPracticeCharacters.btnClearDisableDisableForSmallMode
        if (
            hasFirstStroke &&
            !isCanvasPlaying
            )
        {
            objCls = cssPracticeCharacters.btnClearForSmallMode
        }
        return objCls
    }

    function GetClsVideoSentenceAndRadicalArea()
    {
        console.log(COMP_NAME + ".GetClsVideoSentenceAndRadicalArea: ")

        let objCls = cssPracticeCharacters.divVideoSentenceAndRadicalArea
        if(IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divVideoSentenceAndRadicalAreaForSmallMode
        }
        return objCls
    }

    function GetClsCharacterDrawerArea()
    {
        console.log(COMP_NAME + ".GetClsCharacterDrawerArea: ")

        let objCls = cssPracticeCharacters.divCharacterDrawerArea
        if(IsPageDisplayModeSmall())
        {
            objCls = cssPracticeCharacters.divCharacterDrawerAreaForSmallMode
        }
        return objCls
    }

    // #endregion Get ClassName and Style

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service
    
    // #region Component
    // #endregion Component

    // #region Render

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssPracticeCharacters.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    }

    function RenderCharacterDrawerArea()
    {
        // console.log(COMP_NAME + ".RenderCharacterDrawerArea: ")

        let objBlockCanvas = RenderCharacterDrawerCanvas()
        // let objBlockTools = RenderCharacterDrawerTools()
        let objBlockTools = (IsPageDisplayModeSmall()) ? RenderCharacterDrawerToolsForSmallMode() : RenderCharacterDrawerTools()

        return (
            <>
                <div className={GetClsCharacterDrawerArea()}>
                    {objBlockCanvas}
                    {objBlockTools}
                </div>
            </>
        )
    }

    function RenderCharacterDrawerTools()
    {
        // console.log(COMP_NAME + ".RenderCharacterDrawerTools: ")
        return (
            <div className={cssPracticeCharacters.divCharacterDrawerCanvasControlToolArea}>

                <div className={GetClsPlayButton()} onClick={() => CanvasPlayOnTapHandler()}></div>

                <div className={GetClsDownloadButton()} onClick={() => CanvasSaveOnTapHandler()}></div>

                <div className={GetClsClearButton()} onClick={() => CanvasClearOnTapHandler()}></div>

                <div className={GetClsEditButton()} onClick={() => StrokeOpenOnTapHandler()}></div>
            </div>
        )
    }

    function RenderCharacterDrawerToolsForSmallMode()
    {
        // console.log(COMP_NAME + ".RenderCharacterDrawerToolsForSmallMode: ")
        return (
            <div className={cssPracticeCharacters.divCharacterDrawerCanvasControlToolAreaForSmallMode}>
                <div className={GetClsEditButtonForSmallMode()} onClick={() => StrokeOpenOnTapHandler()}></div>
                <div className={GetClsPlayButtonForSmallMode()} onClick={() => CanvasPlayOnTapHandler()}></div>
                <div className={GetClsDownloadButtonForSmallMode()} onClick={() => CanvasSaveOnTapHandler()}></div>
                <div className={GetClsClearButtonForSmallMode()} onClick={() => CanvasClearOnTapHandler()}></div>
            </div>
        )
    }

    function RenderItemVideoArea()
    {
        // console.log(COMP_NAME + ".RenderItemVideoArea")

        let strVideoFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.Character[currentCharIndex].MajorVideoFN : props.LUInfo.Character[currentCharIndex].MinorVideoFN

        let strImageFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.Character[currentCharIndex].MajorImgFN : props.LUInfo.Character[currentCharIndex].MinorVideoFN

        console.log("strVideoFN:", strVideoFN)
        console.log("strImageFN:", strImageFN)

        let strAudioFN = props.LUInfo.Character[currentCharIndex].Sentence.AudioFN
        console.log("strAudioFN:", strAudioFN)

        mstrCharacterVideoUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Video, strVideoFN)
        mstrCharacterImageUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image, strImageFN)
        console.log("mstrCharacterVideoUrl:", mstrCharacterVideoUrl)
        console.log("mstrCharacterImageUrl:", mstrCharacterImageUrl)

        mstrCharacterAudioUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, strAudioFN)
        console.log("mstrCharacterAudioUrl:", mstrCharacterAudioUrl)

        return(
            <>
                {RenderItemVideoIFrame()}
            </>
        )
    }

    function RenderCharacterDrawerCanvas()
    {
        // console.log(COMP_NAME + ".RenderCharacterDrawerCanvas: ")

        const WORKING_AREA_W = 210
        const WORKING_AREA_H = 210

        let objInitCanvasParams = {
            "CanvasWidthLP": WORKING_AREA_W,      // LP: Logic Point
            "CanvasHeightLP": WORKING_AREA_H,      // LP: Logic Point
            "CanvasLeftLP": 0,
            "CanvasTopLP": 0,
            "DevicePixelRatio": window.devicePixelRatio     // iPad Retina: 2    
        }

        
        return (
            <div className={GetClsCharacterDrawerCanvasArea()}
                onTouchStart={(event) => DisableChangePageByTouchEvent(event)}
                onTouchEnd={(event) => EnableChangePageByTouchEvent(event)}
            >
                <CharacterDrawerCanvas InitParam={objInitCanvasParams} CallbackRef={ComponentCallback} />
            </div>
        )
    }

    function RenderItemVideoIFrame()
    {
        // console.log(COMP_NAME + ".RenderItemVideoIFrame")

        let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)
        let strInApp4QueryString = window.Globals.GetQueryString4InApp()
        let strSupportLang = "en-US"
        let strTargetLang = "zh-CN"
        let strQueryString = "Credential=" + window.gSession.Acc.Credential
        let strTargetDomain = window.location.protocol + "//" + window.location.hostname

        if (
            (typeof (window.location.port) !== 'undefined') &&
            (window.location.port !== null) &&
            (window.location.port !== "")
            )
        {
            strTargetDomain += ":" + window.location.port
        }

        // console.log("strTargetDomain: ", strTargetDomain)
        // console.log("window.location: ", window.location)
        // console.log("window.gSession.App.Env:", window.gSession.App.Env)
        // console.log("intEnv: ", intEnv)
        // console.log("strInApp4QueryString: ", strInApp4QueryString)
        
        strTargetDomain = encodeURIComponent(strTargetDomain)
        strQueryString = strQueryString + "&TargetDomain=" + strTargetDomain
        strQueryString = strQueryString + "&Env=" + intEnv.toString()           //"2", window.gSession.App.Env
        strQueryString = strQueryString + strInApp4QueryString
        strQueryString = strQueryString + "&SysType=" + window.gSession.App.SysType.toString()
        strQueryString = strQueryString + "&SupportLang=" + strSupportLang
        strQueryString = strQueryString + "&TargetLang=" + strTargetLang

        let strVideoPlayerUrl = PackageVariablesLibs.SysConfig.AppWebDomain + "/BCVideoPlayer/?" + strQueryString
        // console.log("strVideoPlayerUrl: ", strVideoPlayerUrl)

        let intIframeKey = currentCharIndex // 為了 當currenCharIndex改畢後 強迫iframe reload
        return (
            <div className={GetClsCharacterVideoPlayerIFrameArea()}>
                <iframe
                    key={intIframeKey} // 為了 當currenCharIndex改畢後 強迫iframe reload
                    title="IframeVideoPlayer" onLoad={IframeOnLoaded} 
                    className={cssPracticeCharacters.iframePlayer} 
                    src={strVideoPlayerUrl} 
                    scrolling="no" allow="autoplay;" allowFullScreen/>
                <div className={GetClsPlayAudioWhenVideoPlayIcon()} onClick={() => PlayAudioWhenVideoPlayOnTapHandler()}></div>
            </div>
        )
    }

    function RenderItemVideoSentenceAndRadicalArea()
    {
        // console.log(COMP_NAME + ".RenderItemVideoSentenceAndRadicalArea")

        let strRadicalDesc = props.LUInfo.Character[currentCharIndex].RadicalDesc
        let strRadical = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.Character[currentCharIndex].RadicalMajor : props.LUInfo.Character[currentCharIndex].RadicalMinor
        let strRadicalPinyin = props.LUInfo.Character[currentCharIndex].RadicalPinyin
        
        console.log("strRadicalDesc:", strRadicalDesc)
        console.log("strRadical:", strRadical)
        console.log("strRadicalPinyin:", strRadicalPinyin)

        let strText = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.Character[currentCharIndex].Sentence.MajorText : props.LUInfo.Character[currentCharIndex].Sentence.MinorText
        let strPinyin = props.LUInfo.Character[currentCharIndex].Sentence.Pinyin
        let strEnglith = props.LUInfo.Character[currentCharIndex].Sentence.Text

        return(
                <div className={cssPracticeCharacters.divCharacterVideoPlayerSentenceAndRadicalArea}>
                    <div className={cssPracticeCharacters.divSentenceAndRadicalUsageExample}>{window.gAppUI.LBL_UsageExample}</div>
                    <div className={cssPracticeCharacters.divSentenceAndRadicalUsageExampleDescriptionAndPinyin}>{strText} {"("}{strPinyin}{")"}</div>
                    <div className={cssPracticeCharacters.divSentenceAndRadicalUsageExampleEnglith}>{strEnglith}</div>
                    <div className={cssPracticeCharacters.divSentenceAndRadicalRadical}>{window.gAppUI.LBL_Radical}</div>
                    <div className={cssPracticeCharacters.divSentenceAndRadicalRadicalDescriptionAndPinyin}>{strRadical} {strRadicalPinyin} {":"} {strRadicalDesc}</div>
                </div>
        )
    }

    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea")

        let strTitleEN = props.SubSectionDef.Name;
        let strTitleCN = '';
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName;
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName;
        }

        return (
            <>
                <div className={cssPracticeCharacters.divTitleLeftArea}>
                    {RenderGoogleClassrommButton()}
                    <div className={cssPracticeCharacters.divTitleSubArea}>
                        <div className={cssPracticeCharacters.divLessonIcon}></div>
                        <div className={cssPracticeCharacters.divLUTitleTextEN}>
                            {strTitleEN}
                        </div>
                        <div className={cssPracticeCharacters.divDividerBar}></div>
                        <div className={cssPracticeCharacters.divLUTitleTextCN}>
                            {strTitleCN}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    function RenderSubTitleArea()
    {
        // console.log(COMP_NAME + ".RenderSubTitleArea: ")

        let strInstruction = ""
        if (
            (typeof (props.LUInfo.Instruction) !== 'undefined') &&
            (props.LUInfo.Instruction !== null) &&
            (props.LUInfo.Instruction !== "")
            )
        {
            strInstruction = props.LUInfo.Instruction;
        }

        return (
            <div className={cssPracticeCharacters.divSubTitleArea}>
                <div className={GetClsSubTitleText()}>
                    {strInstruction}
                </div>
            </div>
        )
    }

    function RenderStrokeVideoAndPracticeArea()
    {
        // console.log(COMP_NAME + ".RenderStrokeVideoAndPracticeArea: ")

        let objBlockVideo = RenderCharacterVideoPlayerArea()
        let objBlockDrawer = RenderCharacterDrawerArea()

        return(
            <div className={cssPracticeCharacters.divStrokeVideoAndPracticeArea}>
                {objBlockVideo}
                {objBlockDrawer}
            </div>
        )
    }

    function RenderCharacterVideoPlayerArea()
    {
        // console.log(COMP_NAME + ".RenderCharacterVideoPlayerArea: ")

        return(
            <div className={GetClsVideoSentenceAndRadicalArea()}>
                {RenderItemVideoArea()}
                {RenderItemVideoSentenceAndRadicalArea()}
            </div>
        )
    }

    function RenderItemForVideo()
    {
        // console.log(COMP_NAME + ".RenderItemForVideo: ")

        let strMagicVideoFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.MagicMajorVideoFN : props.LUInfo.MagicMinorVideoFN
        // let strMagicImgFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.MagicMajorImgFN : props.LUInfo.MagicMinorImgFN
        let strMagicMinImgFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? props.LUInfo.MagicMajorMinImgFN : props.LUInfo.MagicMinorMinImgFN
        
        let objBlockItemForVidoe = null
        if(
            (typeof(strMagicVideoFN) !== "undefined") &&
            (strMagicVideoFN !== null) &&
            (typeof(strMagicMinImgFN) !== "undefined") &&
            (strMagicMinImgFN !== "")
        )
        {
            objBlockItemForVidoe = <div className={GetClsItemForVideo()} style={GetStyleItemForVideo(strMagicMinImgFN)} onClick={() => ItemVideoOnTapHandler(strMagicVideoFN, strMagicMinImgFN)}>
                <div className={GetClsItemForVideoPlayIcon()}></div>
            </div>
        }
        return objBlockItemForVidoe
    }

    function RenderItemForCharacter(CharacterItem, CharacterIndex)
    {
        // console.log(COMP_NAME + ".RenderCharacterList: ", CharacterItem)
        
        let strVideoFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? CharacterItem.MajorVideoFN : CharacterItem.MinorVideoFN
        let strImageFN = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? CharacterItem.MajorImgFN : CharacterItem.MinorImgFN

        let objBlockItemForCharacter = null
        if(
            (typeof(strVideoFN) !== "undefined") &&
            (strVideoFN !== null) &&
            (typeof(strImageFN) !== "undefined") &&
            (strImageFN !== "")
        )
        {
            objBlockItemForCharacter = <div key={CharacterIndex} className={GetClsItemCharacter(currentCharIndex, CharacterIndex)} style={GetStyleItemForCharacter(strImageFN)} onClick={() => ItemCharacterOnTapHandler(CharacterIndex)}></div>
        }

        return objBlockItemForCharacter
    }

    function RenderCharacterScrollArea()
    {
        // console.log(COMP_NAME + ".RenderCharacterList: ")  
        console.log("props.LUInfo.Character:", props.LUInfo.Character)  
        
        return(
            <div className={GetClsCharacterList()}
                onTouchStart={(event) => DisableChangePageByTouchEvent(event)}
                onTouchEnd={(event) => EnableChangePageByTouchEvent(event)}
            >
                {RenderItemForVideo()}
                {props.LUInfo.Character.map((CharacterItem, CharacterIndex) => RenderItemForCharacter(CharacterItem, CharacterIndex))}
            </div>
        )
    }

    function RenderContent()
    {
        // console.log(COMP_NAME + ".RenderContent: ")
        return (
            <div className={cssPracticeCharacters.divContentArea} >
                {RenderSubTitleArea()}
                {RenderStrokeVideoAndPracticeArea()}
                {RenderCharacterScrollArea()}
            </div>
        )
    }

    return (
        <>
            {RenderHeaderLeftArea()}
            {RenderContent()}
        </>
    )
    // #endregion Render
}
export default PracticeCharacters